import { Divider as AntDivider, Space } from 'antd';
import styled from 'styled-components';

import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const FormWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 318px;
`;

export const Divider = styled(AntDivider)`
  border-block-start-color: ${(props) => props.theme.Divider.mainColor};
  margin: 24px 0 22px 0;
`;

export const ButtonSpace = styled(Space)`
  display: flex;
  margin-top: 8px;
`;

export const ButtonTitle = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorSignUpSocialTitle,
  level: 'm',
}))``;

export const NewUserParagraph = styled(Text).attrs(() => ({
  color: ColorEnum.Black100,
  level: 'l',
  weight: 400,
  paragraph: true,
}))`
  padding-top: 2px;
  margin-bottom: 8px !important;
`;
